"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.SymbolFeatureConfiguration = exports.SingleLetterFeatureConfiguration = exports.TextFeatureConfiguration = exports.DesignerFeatureBuilder = exports.DesignerFeatureType = void 0;
var DesignerFeatureType;
(function (DesignerFeatureType) {
    DesignerFeatureType["TEXT"] = "TEXT";
    DesignerFeatureType["SINGLE_LETTER"] = "SINGLE_LETTER";
    DesignerFeatureType["SYMBOL"] = "SYMBOL";
})(DesignerFeatureType = exports.DesignerFeatureType || (exports.DesignerFeatureType = {}));
var DesignerFeatureBuilder = /** @class */ (function () {
    function DesignerFeatureBuilder(designerFeature) {
        this.designerFeature = designerFeature;
    }
    DesignerFeatureBuilder.initialiseWithDesignerFeature = function (designerFeature) {
        return new DesignerFeatureBuilder(designerFeature);
    };
    DesignerFeatureBuilder.initialiseWithText = function (availableFontIds) {
        return new DesignerFeatureBuilder({
            type: DesignerFeatureType.TEXT,
            textFeatureConfiguration: __assign(__assign({}, TextFeatureConfiguration.defaultTextFeatureConfiguration), { availableFontIds: availableFontIds })
        });
    };
    DesignerFeatureBuilder.initialiseWithSingleLetter = function (availableFontIds) {
        return new DesignerFeatureBuilder({
            type: DesignerFeatureType.SINGLE_LETTER,
            singleLetterFeatureConfiguration: __assign(__assign({}, SingleLetterFeatureConfiguration.defaultSingleLetterFeatureConfiguration), { availableFontIds: availableFontIds })
        });
    };
    DesignerFeatureBuilder.initialiseWithSymbol = function (availableSymbolCollectionIds) {
        return new DesignerFeatureBuilder({
            type: DesignerFeatureType.SYMBOL,
            symbolFeatureConfiguration: __assign(__assign({}, SymbolFeatureConfiguration.defaultSymbolFeatureConfiguration), { availableSymbolCollectionIds: availableSymbolCollectionIds })
        });
    };
    DesignerFeatureBuilder.prototype.build = function () {
        return this.designerFeature;
    };
    return DesignerFeatureBuilder;
}());
exports.DesignerFeatureBuilder = DesignerFeatureBuilder;
var TextFeatureConfiguration = /** @class */ (function () {
    function TextFeatureConfiguration() {
    }
    TextFeatureConfiguration.defaultTextFeatureConfiguration = {
        availableFontIds: [],
        minFontSize: 1.3,
        deltaFontSize: 0.5
    };
    return TextFeatureConfiguration;
}());
exports.TextFeatureConfiguration = TextFeatureConfiguration;
var SingleLetterFeatureConfiguration = /** @class */ (function () {
    function SingleLetterFeatureConfiguration() {
    }
    SingleLetterFeatureConfiguration.defaultSingleLetterFeatureConfiguration = {
        availableFontIds: [],
        minFontSize: 2.3,
        deltaFontSize: 0.5
    };
    return SingleLetterFeatureConfiguration;
}());
exports.SingleLetterFeatureConfiguration = SingleLetterFeatureConfiguration;
var SymbolFeatureConfiguration = /** @class */ (function () {
    function SymbolFeatureConfiguration() {
    }
    SymbolFeatureConfiguration.defaultSymbolFeatureConfiguration = {
        availableSymbolCollectionIds: [],
        minScalingFactor: 1,
        deltaScalingFactor: 0.5
    };
    return SymbolFeatureConfiguration;
}());
exports.SymbolFeatureConfiguration = SymbolFeatureConfiguration;
